import Layout from "@/layout/index.vue";

export default [
  // 商务管理
  {
    path: "/business",
    name: "business",
    component: Layout,
    redirect: "/business/manager",
    meta: {
      title: "商务管理",
    },
    children: [
      {
        path: "/business/manager",
        name: "businessManager",
        component: () => import("@/views/business/pages/manager/index.vue"),
        meta: {
          title: "商务管理",
          newPage: true,
        },
      },
    ],
  },
]
